export default "__VITE_ASSET__DHrSCmE7__"